import { Flex, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

import NewsCard from '../NewsCard'
import { ArticlesByDate, formatMonthLabel, getMonthKey } from '../../utils'

interface Props {
    articlesByDate: ArticlesByDate
}

const NewsList = ({ articlesByDate }: Props): JSX.Element => {
    const { t } = useTranslation()
    const groups = Object.entries(articlesByDate)

    return (
        <Flex direction={'column'} gap={'16px'} w={'full'} pb={'24px'}>
            {groups.map(([dateKey, articles], index) => {
                const isNewMonth = getMonthKey(dateKey) !== (index > 0 ? getMonthKey(groups[index - 1][0]) : '')

                return (
                    <Flex key={dateKey} direction={'column'} gap={'16px'}>
                        {isNewMonth ? (
                            <Text
                                mt={index > 0 ? '16px' : undefined}
                                fontSize={'14px'}
                                fontWeight={'600'}
                                color={'#4B4B4E'}
                                lineHeight={'20px'}
                            >
                                {formatMonthLabel(dateKey, t)}
                            </Text>
                        ) : null}
                        {articles.map((article) => (
                            <NewsCard key={article.NewsfeedID} article={article} />
                        ))}
                    </Flex>
                )
            })}
        </Flex>
    )
}

export default NewsList
